import React from 'react';
import PropTypes from 'prop-types';

import TransactionPresenter from '../../../../../../presenters/TransactionPresenter';
import ListSkeleton from '../../../../../../components/Skeletons/ListSkeleton';
import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';
import Pagination from '../../../../../../components/Pagination';

import Transaction from './components/Transaction';

const TransactionsTable = (props) => {
  const { transactions, loadingState, meta, onPageChange } = props;

  const { isFulfilled } = useFetchStatus(loadingState);

  if (!isFulfilled) {
    return <ListSkeleton height={15} width={500} />;
  }

  const isTransactionsEmpty = transactions.length === 0;

  if (isTransactionsEmpty) {
    return <div className="empty-table">No data for selected parameters</div>;
  }

  return (
    <div>
      <table className="tables">
        <thead>
          <tr>
            <th>Date</th>
            <th>Transaction Name</th>
            <th>Store Name</th>
            <th>Location</th>
            <th>Merchant Name</th>
            <th>Amount</th>
            <th>Status</th>
            <th>CashbackRate</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction, index, transactions) => {
            const previousTransaction = transactions[index - 1];
            return (
              <Transaction
                key={transaction.id}
                transaction={transaction}
                previousTransaction={previousTransaction}
              />
            );
          })}
        </tbody>
      </table>
      <Pagination meta={meta} onPageChange={onPageChange} />
    </div>
  );
};

export default TransactionsTable;

TransactionsTable.propTypes = {
  transactions: PropTypes.arrayOf(TransactionPresenter.shape()),
  meta: PropTypes.shape().isRequired,
  onPageChange: PropTypes.func.isRequired,
  loadingState: PropTypes.string.isRequired,
};

TransactionsTable.defaultProps = {
  transactions: [],
};
